import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "$5874 March sidehustle report",
  "description": "",
  "published": "2017-04-04T00:00:00.000Z",
  "redirect_from": ["/blog/march-2017-sidehustle-report/swizec/7540"],
  "categories": "Business, Side Projects",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <lite-youtube {...{
      "videoid": "cZPQk7wpYbY",
      "videostartat": "0"
    }}></lite-youtube>
    <p>{`In March, my sidehustle made $5,874 in gross pre-tax revenue. That's just $200 short of my post-tax day job income. ?`}</p>
    <p>{`Unfortunately, this is not a trend. There were bumps, and I already know April is going to be slow. Unless a few Hail Marys come through… you don't wanna rely on Hail Marys when rent is due, though. :D`}</p>
    <p>{`Here's why that revenue can't pay rent (yet):`}</p>
    <p><img parentName="p" {...{
        "src": "https://swizec.com/blog/wp-content/uploads/2017/04/gumroad-screenshot.png",
        "alt": null
      }}></img></p>
    <p>{`Such stable sales LOL`}</p>
    <p><strong parentName="p">{`Total revenue:`}</strong>{` $5874`}</p>
    <p><strong parentName="p">{`Gumroad sales:`}</strong></p>
    <ul>
      <li parentName="ul">{`React + D3v4 preorders: $381 - fees`}</li>
      <li parentName="ul">{`ES6 Cheatsheet: $50 - fees`}</li>
      <li parentName="ul">{`React + D3 ES6: $886 - fees`}</li>
    </ul>
    <p><strong parentName="p">{`Leanpub sales:`}</strong>{` $249`}</p>
    <ul>
      <li parentName="ul">{`Why Programmers Work at Night: $8`}</li>
      <li parentName="ul">{`React + D3 ES6: $92`}</li>
      <li parentName="ul">{`React + D3v4: $149`}</li>
    </ul>
    <p><strong parentName="p">{`Packt royalties:`}</strong>{` $514`}</p>
    <p><strong parentName="p">{`React Native School:`}</strong>{` $1464`}</p>
    <p><strong parentName="p">{`In-Person Workshops:`}</strong>{` $1819`}</p>
    <ul>
      <li parentName="ul">{`ForwardJS: $256`}</li>
      <li parentName="ul">{`Self-organized: $1534`}</li>
    </ul>
    <p><strong parentName="p">{`Time investment:`}</strong>{` 96 hours`}</p>
    <p><strong parentName="p">{`Cost:`}</strong>{` $2277`}</p>
    <ul>
      <li parentName="ul">{`More camera gear: $279`}</li>
      <li parentName="ul">{`Editor: $575`}</li>
      <li parentName="ul">{`VA: $337`}</li>
      <li parentName="ul">{`Apple Developer Account: $107`}</li>
      <li parentName="ul">{`reactd3js.com domain: $10`}</li>
      <li parentName="ul">{`AppSumo: $99`}</li>
      <li parentName="ul">{`Drip: $184`}</li>
      <li parentName="ul">{`Hosting: $10`}</li>
      <li parentName="ul">{`LiveEdu account: $10`}</li>
      <li parentName="ul">{`Ads (Facebook + Twitter): $256`}</li>
      <li parentName="ul">{`Lunch for workshop peeps: $60`}</li>
      <li parentName="ul">{`Workshop space: $350`}</li>
    </ul>
    <p><strong parentName="p">{`Net hourly rate:`}</strong>{` $37 pre-tax`}</p>
    <p>{`That's $5 more than last month! ?? I've arrived!`}</p>
    <p><img parentName="p" {...{
        "src": "/1efac8baa257cccbb640572c87d44f41/ZPFQVis9WAAcE.gif",
        "alt": null
      }}></img></p>
    <p>{`You might not notice this, but there are plenty of business failings in those numbers. The new React+D3v4 edition is better priced, a better product, `}<em parentName="p">{`and`}</em>{` people who read it rave about how great it is.`}</p>
    <p>{`It's making low sales because 1) I'm not advertising it and 2) if you don't know it exists, you'll never find it. None of my websites, not even the book's landing page, link to it. There isn't even a buy button unless you send me an email and say, `}<em parentName="p">{`"Yo dude, your book looks outdated"`}</em>{`. Then I send you an email like `}<em parentName="p">{`"Yes, here's the new one.”`}</em></p>
    <p>{`This is terrible, and I should feel bad. (hint: I do)`}</p>
    <p>{`Yes, I should `}<em parentName="p">{`just`}</em>{` fix it. As time passes, emotional baggage builds around that "just". The book is not done yet, I'm gonna feel even more pressures once I switch the buy buttons, the landing page copy needs to be redone, the page itself needs redoing, I have to set up ads, there are emails to send, even more existing customers need to be sent their free upgrade, there's more and more of them every week that I don't change the landing page and just so many different things…`}</p>
    <p>{`Why can't I just build cool shit and let all that other stuff care for itself?`}</p>
    <p>{`Oh yeah, 'cause I haven't hired anyone to handle that. Because I'm too swamped to spend time finding people to help me.`}</p>
    <p>{`Nice spiral of doom, that one. Working `}<em parentName="p">{`on`}</em>{` the business versus working `}<em parentName="p">{`in`}</em>{` the business. ?`}</p>
    <p>{`And `}<a parentName="p" {...{
        "href": "http://swizec.com/blog/boutique-react-d3v4-workshop/swizec/7519"
      }}>{`the workshop… that was great`}</a>{`. Magnificent. People loved it. We sold 6 tickets out of the 12 tickets we had. Don't start marketing stuff like that two weeks before it happens. Lesson learned.`}</p>
    <p>{`The Chicago workshop in May is going to do even better.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      